import type { GetPastPetCaregiversParsedResponse } from "webApp";
export const getPastPetCaregiversResponseParser = (response: GetPastPetCaregiversParsedResponse) => response.pastPetCaregiverSummaries;